export default class Icons {
  static load(path) {
    const finalPath = path || '/assets/icons.svg';

    fetch(finalPath)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Le fichier icons est introuvable.');
        }
        return res.text();
      })
      .then((data) => {
        const svgContainer = document.createElement('div');
        svgContainer.style.display = 'none';
        svgContainer.innerHTML = data;
        document.body.appendChild(svgContainer);
      })
      .catch((error) => {
        console.error(`Une erreur est survenue : ${error.message}`);
      });
  }
}